import { render, staticRenderFns } from "./ListLiveAlertContactMessage.vue?vue&type=template&id=33f3ccff"
import script from "./ListLiveAlertContactMessage.vue?vue&type=script&lang=js"
export * from "./ListLiveAlertContactMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports